import { getCleanUrl } from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';

export const useIsSplashPage = () => {
    const { splashPage, enableSplashPage } = useAppSelector;

    return getCleanUrl() === splashPage && enableSplashPage;
};
